<template>
  <div class="field-option-customer-info-group-wrapper">
    <field-option-customer-info
      v-for="(item, index) of items"
      :key="index"
      :sty="sty"
      :name="name"
      :idcard="idcard"
      @change="$event => handleFieldChange(index, $event)"
    />
  </div>
</template>
<script>
import FieldOptionCustomerInfo from './FieldOptionCustomerInfo.vue';

export default {
  components: {
    FieldOptionCustomerInfo,
  },
  props: {
    items: [Array],
    sty: [Number],
    name: [Number],
    idcard: [Number],
  },
  methods: {
    handleFieldChange(index, item) {
      const items = this.items.map((innerItem, innerIndex) =>
        index === innerIndex ? item : innerItem
      );
      this.$emit('change', items);
    },
  },
};
</script>
<style lang="less" scoped></style>
